import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { StakingContext } from '../../../../contexts/staking/context';
import { useAccountRestriction } from '../../../../utilities/sharedHooks/account';
import { USER_CREATE_WALLET } from '../../../Accounts/mutations';
import { featuresModales, mainStakingCurrency } from '../../constants';
import FeatureMainBodyLayout from '../../partials/FeatureMainBodyLayout';
import OptionButton from '../../partials/OptionButton';
import { useUserPersonalInfo } from '../../../../utilities/sharedHooks/user';

const AddFundsOptions = () => {
  const { t: translate } = useTranslation();

  const { state, toggleModal } = useContext(StakingContext);

  const mainStakingWallet = state?.mainStakingWallet;
  const allWallets = state?.wallets;

  const { restrictions } = useAccountRestriction(mainStakingCurrency);

  const history = useHistory();

  const { isUS } = useUserPersonalInfo();

  const isDepositHidden = useMemo(
    () => process.env.REACT_APP_DEPOSIT_BUTTON_HIDDEN && !isUS,
    [isUS]
  );

  const { mutate: createWallets, isLoading: isCreatingWallets } = useMutation(USER_CREATE_WALLET, {
    onSettled: () => {
      toggleModal(featuresModales.EXCHANGE, true);
    },
  });

  const handleBuyBXXAction = () => {
    const usdtWallet = allWallets?.find((w) => w.coin === 'usdt');

    if (usdtWallet) {
      toggleModal(featuresModales.EXCHANGE, true);
    } else {
      createWallets({
        wallets: ['usdt'],
      });
    }
  };

  const options = useMemo(
    () => [
      {
        label: translate('staking_buy_bxx_option'),
        onClick: handleBuyBXXAction,
        icon: 'icon-wallet',
        disabled: !mainStakingWallet?.id || restrictions?.exchangeDisabled || isCreatingWallets,
        loading: isCreatingWallets ? 'true' : 'false',
        hidden: false,
      },
      {
        label: translate('staking_top_up_bxx_option'),
        onClick: () => toggleModal(featuresModales.ADD_FUNDS, true),
        icon: 'icon-withdraw-card',
        disabled: !mainStakingWallet?.id || restrictions?.receiveDisabled,
        loading: false,
        hidden: isDepositHidden,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mainStakingWallet, restrictions, isCreatingWallets, isDepositHidden]
  );

  return (
    <FeatureMainBodyLayout
      withBack
      onPrevClick={() => history.push('/dashboard/staking')}
      title={translate('add_bxx_screen_title')}>
      <p className="text-dark text-f5 mt-4 pt-3 mb-3">{translate('add_bxx_screen_subtitle')}</p>
      {options
        .filter((option) => !option.hidden)
        .map((option) => (
          <OptionButton
            className="mt-2"
            key={option.label}
            label={option.label}
            icon={option.icon}
            iconSize="text-f3"
            onClick={option.onClick}
            disabled={option.disabled}
          />
        ))}
    </FeatureMainBodyLayout>
  );
};

export default AddFundsOptions;
